<template>
  <div class="toggle-row">

    <div class="row m-0">
      <div class="col-md-12 p-0">
        <h5 class="bg-teal p-2 mb-3 rounded text-center">Refine</h5>
      </div>
    </div>
    <div class="row tab-row-data m-0">
      <div class="col-md-12">
        <div class="row m-0">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Term/Year Toggle</h5>
          <div class="col-12 mb-3">
            <div class="d-flex align-items-center mod-toggle justify-content-center">
              <div class="status-toggle">
                <input type="checkbox" id="toggle" class="check" v-model="isYear" />
                <label for="toggle" class="checktoggle"></label>
              </div>
              <label for="toggle" class="checktoggle">{{ isYear ? 'Show as Year' : 'Show as Term' }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <!-- Filter by Term (Months) -->
        <div class="row m-0" v-if="!isYear">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Filter by term</h5>
          <div class="col-12">
            <CustomMinMaxSlider class="my-3" @update-min="handleMinUpdate" @update-max="handleMaxUpdate"
              :initialMinValue="minMonths" :initialMaxValue="maxMonths" />
          </div>
        </div>
        <!-- Filter by Year (Checkboxes) -->
        <div class="row m-0 justify-content-center" v-if="isYear">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Filter by year</h5>
          <div class="col-2 text-center" v-for="year in years" :key="year">
            <div class="form-wrap">
              <label class="col-form-label">{{ year }}</label>
              <input type="checkbox" class="form-check-input year-checkbox" v-model="selectedYears" :value="year"
                @change="emitSelectedYears" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row m-0">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Pricing Window Filter
          </h5>
          <p>Hide suppliers that are outside of the pricing window</p>
          <div class="col-12">
            <div class="d-flex align-items-center mod-toggle ps-2">
              <div class="status-toggle">
                <input type="checkbox" id="toggleMainSup" class="check" v-model="showMainSuppliersOnly" />
                <label for="toggleMainSup" class="checktoggle"></label>
              </div>
              <label for="toggleMainSup" class="checktoggle">
                Show Main Suppliers Only
              </label>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex align-items-center mod-toggle ps-2">
              <div class="status-toggle">
                <input type="checkbox" id="toggleRenewable" class="check" v-model="showRenewableOnly" />
                <label for="toggleRenewable" class="checktoggle"></label>
              </div>
              <label for="toggleRenewable" class="checktoggle">
                Renewable
              </label>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex align-items-center mod-toggle ps-2">
              <div class="status-toggle">
                <input type="checkbox" id="toggleSup" class="check" />
                <label for="toggleSup" class="checktoggle"></label>
              </div>
              <label for="toggleSup" class="checktoggle">Hide Supplier</label>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex align-items-center mod-toggle ps-2">
              <div class="status-toggle">
                <input type="checkbox" id="toggleCommission" class="check" />
                <label for="toggleCommission" class="checktoggle"></label>
              </div>
              <label for="toggleCommission" class="checktoggle">Show total commission</label>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex align-items-center mod-toggle ps-2">
              <div class="status-toggle">
                <input type="checkbox" id="toggleUplift" class="check" />
                <label for="toggleUplift" class="checktoggle"></label>
              </div>
              <label for="toggleUplift" class="checktoggle">Show Uplift(pence/kWh)</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-2">
        <div class="row m-0">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Filter by supplier
          </h5>
          <div class="col-12">
            <div class="d-flex align-items-center mod-toggle justify-content-center">
              <div class="status-toggle">
                <input type="checkbox" id="toggleQuotes" class="check" v-model="isCustomQuote"
                  @change="emitSupplierRateList" />
                <label for="toggleQuotes" class="checktoggle"></label>
              </div>
              <label for="toggleQuotes" class="checktoggle">Include Custom Quotes</label>
            </div>
          </div>
          <div class="col-12">
            <!-- Checkboxes List -->

            <!-- <div class="d-flex align-items-center mod-toggle" v-for="(supplier, index) in uniqueSuppliers" :key="index">
            <input type="checkbox" :id="index" class="form-check-input" v-model="checkboxStates[index]" @change="emitSelectedSuppliers" />
            <label :for="index" class="checktoggle ms-2">{{ supplier.Supplier }}</label>
          </div> -->


            <div v-for="(supplier, index) in filteredSuppliers" :key="index" class="mb-1">
              <!-- Supplier Row -->
              <!-- <div class="d-flex align-items-center">
                <input type="checkbox" :id="'supplier-' + index" v-model="checkboxStates[index]"
                  @change="emitSelectedSuppliers(index, checkboxStates[index])" />
                <label class="ms-2" @click="toggleDropdown(index)">
                  {{ supplier.Supplier }}
                </label>
              </div> -->

              <div class="d-flex align-items-center justify-content-between arrow-icon">
                <div class="d-flex align-items-center">
                  <input type="checkbox" :id="'supplier-' + index" v-model="checkboxStates[index]"
                    @change="emitSelectedSuppliers(index, checkboxStates[index])" :checked="isAllTermsSelected(index)"
                    :indeterminate="isPartialTermsSelected(index)" />
                  <label class="ms-2" @click="toggleDropdown(index)">
                    {{ supplier.Supplier }}
                  </label>
                </div>

                <span @click="toggleDropdown(index)" style="cursor: pointer;">
                  <i :class="showDropdown[index] ? 'ti ti-chevron-up' : 'ti ti-chevron-down'"></i>
                </span>

              </div>

              <!-- PlanType & Term Dropdown -->
              <div v-if="showDropdown[index]" class="ms-4 mt-1">
                <!-- Terms -->
                <div class="" v-if="supplier.Term.length">
                  <strong>Contract Term</strong>
                  <div v-for="(term, tIndex) in supplier.Term" :key="tIndex">
                    <input type="checkbox" :id="'term-' + index + '-' + tIndex" v-model="selectedTerms[index][tIndex]"
                      :value="term" @change="emitSelectedTerms(index)" />
                    <label :for="'term-' + index + '-' + tIndex" class="ms-1">
                      {{ term }}
                    </label>
                  </div>
                </div>
                <!-- Plan Type -->
                <div v-if="supplier.PlanType.length">
                  <strong>Product
                  </strong>
                  <div v-for="(plan, pIndex) in supplier.PlanType" :key="pIndex">
                    <input type="checkbox" :id="'plan-' + index + '-' + pIndex" v-model="selectedPlans[index][pIndex]"
                      :value="plan || 'Default'" @change="emitSelectedPlans(index)" />
                    <label :for="'plan-' + index + '-' + pIndex" class="ms-1">
                      {{ plan || 'Default' }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Toggle Button for Check All/Uncheck All -->
            <div class="d-flex justify-content-center my-3">
              <button class="btn btn-warning py-2" @click="toggleAll">
                Toggle all
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row m-0">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Export settings
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  watch,
  computed
} from "vue";
import {
  useStore,
  mapGetters
} from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";
import {
  Form,
  Field,
  ErrorMessage
} from "vee-validate";
import * as Yup from "yup";
import CustomMinMaxSlider from "./CustomMinMaxSlider.vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
const currentDateTwo = ref(new Date());

export default {
  props: {
    uniqueSuppliers: {
      type: Array,
      default: () => [], // Default to an empty array
    },
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    CustomMinMaxSlider
  },
  data() {
    return {
      startdate: currentDate,
      startdateOne: currentDateOne,
      startdateTwo: currentDateTwo,
      dateFormat: "dd/MM/yyyy",
    };
  },
  setup(props, {
    emit
  }) {
    const store = useStore();
    const isYear = ref(false); // Toggle between year and term
    // Reactive variables to hold min and max values
    const minMonths = ref(12);
    const maxMonths = ref(60);
    // Methods to handle emitted events
    const handleMinUpdate = (newMin) => {
      minMonths.value = newMin;
      emit('min-months', newMin);
    };

    const showDropdown = ref({})
    const selectedPlans = ref({})
    const selectedTerms = ref({})
    const isCustomQuote = ref(true)

    const handleMaxUpdate = (newMax) => {
      maxMonths.value = newMax;
      emit('max-months', newMax);
    };
    const years = ref([1, 2, 3, 4, 5]); // Years to show in checkboxes
    const selectedYears = ref([]); // Selected year checkboxes

    const checkboxStates = ref([]);

    // Computed property to check if all are checked
    const allChecked = computed(() => {
      return checkboxStates.value.length > 0 && checkboxStates.value.every(checked => checked);
    });
    const showMainSuppliersOnly = ref(true);
    const showRenewableOnly = ref(false);

    const mainSuppliers = [
      "British Gas",
      "British Gas Lite",
      "Corona Energy",
      "Crown Gas & Power",
      "EDF Energy",
      "E-on Next",
      "Npower",
      "Pozitive Energy",
      "Scottish Power",
      "SEFFE Energy",
      "Smartest Energy",
      "Scottish And Southern",
      "TotalEnergies",
      "Valda Energy",
      "Yorkshire Gas & Power",
      "Yu Energy"
    ];
    const normalizeSupplier = (name) =>
      name?.trim().replace(/\s+/g, " ").toLowerCase();

    const mainSupplierSet = new Set(
      mainSuppliers.map(normalizeSupplier)
    );

    const filteredSuppliers = computed(() => {
      return props.uniqueSuppliers.filter((supplier) => {
        const isMainSupplier = mainSupplierSet.has(
          normalizeSupplier(supplier.Supplier)
        );
        // Main Supplier filter
        if (showMainSuppliersOnly.value && !isMainSupplier) {
          return false;
        }

        // Renewable filter
        if (showRenewableOnly.value && !supplier.IsRenewable) {
          return false;
        }
        return true;
      });
    });
    // Initialize the checkbox states, check all by default
    const initializeCheckboxStates = () => {
      selectedPlans.value = []
      selectedTerms.value = []
      checkboxStates.value = Array(filteredSuppliers.value.length).fill(true); // Check all by default
      showDropdown.value = Array(filteredSuppliers.value.length).fill(false); // Check all by default
      filteredSuppliers.value.map((item, index) => {
        selectedPlans.value.push([])
        item.PlanType.map((plan) => {
          selectedPlans.value[index].push(true)
        })
        selectedTerms.value.push([])
        item.Term.map((term) => {
          selectedTerms.value[index].push(true)
        })
      })
    };

    const initializeCheckboxStatesChange = (newSuppliers, oldSuppliers) => {
      const prevPlans = selectedPlans.value || [];
      const prevTerms = selectedTerms.value || [];
      const prevCheckboxes = checkboxStates.value || [];

      selectedPlans.value = [];
      selectedTerms.value = [];
      checkboxStates.value = [];
      showDropdown.value = [];

      newSuppliers.forEach((supplier, newIndex) => {
        const supplierName = supplier.Supplier;

        // Find matching supplier in old list
        const prevIndex = oldSuppliers?.findIndex(
          (old) => old?.Supplier === supplierName
        );

        // New supplier
        if (prevIndex === -1 || prevIndex === undefined) {
          checkboxStates.value.push(true);
          showDropdown.value.push(false);
          selectedPlans.value.push(supplier.PlanType.map(() => true));
          selectedTerms.value.push(supplier.Term.map(() => true));
        }
        // else {
        //   // Existing supplier
        //   checkboxStates.value.push(prevCheckboxes[prevIndex] ?? true);
        //   showDropdown.value.push(false);

        //   const prevPlanList = prevPlans[prevIndex] || [];
        //   const newPlanList = supplier.PlanType.map((_, pIdx) =>
        //     prevPlanList[pIdx] !== undefined ? prevPlanList[pIdx] : true
        //   );
        //   selectedPlans.value.push(newPlanList);

        //   const prevTermList = prevTerms[prevIndex] || [];
        //   const newTermList = supplier.Term.map((_, tIdx) =>
        //     prevTermList[tIdx] !== undefined ? prevTermList[tIdx] : true
        //   );
        //   selectedTerms.value.push(newTermList);
        // }

        else {
          // Existing supplier
          checkboxStates.value.push(prevCheckboxes[prevIndex] ?? true);
          showDropdown.value.push(false);

          const prevPlanList = prevPlans[prevIndex] || [];
          const prevTermList = prevTerms[prevIndex] || [];

          const currentPlanTypes = supplier.PlanType.length ? supplier.PlanType : ["Default"];
          const currentTerms = supplier.Term;

          const newPlanList = [];
          const newTermList = [];

          let planAdded = false;
          let termAdded = false;

          // Build PlanType state
          currentPlanTypes.forEach((plan, pIdx) => {
            const exists = prevPlanList[pIdx] !== undefined;
            if (!exists) planAdded = true;
            newPlanList.push(exists ? prevPlanList[pIdx] : true); // If new, set to true
          });

          // Build Term state
          currentTerms.forEach((term, tIdx) => {
            const exists = prevTermList[tIdx] !== undefined;
            if (!exists) termAdded = true;
            newTermList.push(exists ? prevTermList[tIdx] : true); // If new, set to true
          });

          // Push new states
          selectedPlans.value.push(newPlanList);
          selectedTerms.value.push(newTermList);

          // 🔁 Apply cross-enabling logic
          if (planAdded) {
            // Enable all terms for this supplier
            selectedTerms.value[prevIndex] = currentTerms.map(() => true);
          }

          if (termAdded) {
            // If PlanType is missing, make it Default
            if (!supplier.PlanType || !supplier.PlanType.length) {
              supplier.PlanType = ["Default"];
              selectedPlans.value[prevIndex] = ["Default"].map(() => true);
            } else {
              // Enable all plan types
              selectedPlans.value[prevIndex] = currentPlanTypes.map(() => true);
            }
          }
        }


      });
    };


    // Emit the selected suppliers based on checkbox states
    // const emitSelectedSuppliers = (index, value) => {
    //   if (index !== null && !value) {
    //     props.uniqueSuppliers[index].PlanType.map((plan, pIndex) => {
    //       selectedPlans.value[index][pIndex] = false
    //     })

    //     props.uniqueSuppliers[index].Term.map((term, tIndex) => {
    //       selectedTerms.value[index][tIndex] = false
    //     })
    //   }

    //   if (index !== null && value) {
    //     props.uniqueSuppliers[index].PlanType.map((plan, pIndex) => {
    //       selectedPlans.value[index][pIndex] = true
    //     })

    //     props.uniqueSuppliers[index].Term.map((term, tIndex) => {
    //       selectedTerms.value[index][tIndex] = true
    //     })
    //   }
    //   const selectedSuppliers = props.uniqueSuppliers.filter((_, index) => checkboxStates.value[index]);
    //   emit("update-selected-suppliers", selectedSuppliers);
    // };

    const emitSelectedSuppliers = (index, value) => {
      if (index !== null) {
        // Update PlanType and Term based on checkbox value
        filteredSuppliers.value[index].PlanType.forEach((_, pIndex) => {
          selectedPlans.value[index][pIndex] = value;
        });

        filteredSuppliers.value[index].Term.forEach((_, tIndex) => {
          selectedTerms.value[index][tIndex] = value;
        });
      }

      // Collect selected suppliers based on either:
      // - checkbox is checked
      // - at least one plan or term is selected
      // const selectedSuppliers = props.uniqueSuppliers.filter((supplier, sIndex) => {
      //   const hasChecked = checkboxStates.value[sIndex];
      //   const hasSelectedPlan = selectedPlans.value[sIndex]?.some(val => val);
      //   const hasSelectedTerm = selectedTerms.value[sIndex]?.some(val => val);

      //   return hasChecked || hasSelectedPlan || hasSelectedTerm;
      // });

      const selectedSuppliers = filteredSuppliers.value.reduce((acc, supplier, sIndex) => {
        const hasChecked = checkboxStates.value[sIndex];
        const hasSelectedPlans = selectedPlans.value[sIndex]?.some(val => val);
        const hasSelectedTerms = selectedTerms.value[sIndex]?.some(val => val);

        // Only include suppliers with selected plans and terms
        if (!hasSelectedPlans || !hasSelectedTerms) {
          return acc;
        }

        const filteredPlans = supplier.PlanType.filter((_, pIndex) => selectedPlans.value[sIndex][pIndex]);
        const filteredTerms = supplier.Term.filter((_, tIndex) => selectedTerms.value[sIndex][tIndex]);

        acc.push({
          Supplier: supplier.Supplier,
          PlanType: filteredPlans,
          Term: filteredTerms
        });

        return acc;
      }, []);

      emit("update-selected-suppliers", selectedSuppliers);
    };


    const emitSupplierRateList = () => {
      emit("update-suppliers-list", isCustomQuote.value);
    }

    // Toggle all checkboxes between checked/unchecked
    const toggleAll = () => {
      const newState = !allChecked.value;
      checkboxStates.value = checkboxStates.value.map(() => newState);
      if (newState) {
        filteredSuppliers.value.map((supplier, index) => {
          supplier.PlanType.map((plan, pIndex) => {
            selectedPlans.value[index][pIndex] = true
          })
          supplier.Term.map((plan, tIndex) => {
            selectedTerms.value[index][tIndex] = true
          })
        })
      } else {
        filteredSuppliers.value.map((supplier, index) => {
          supplier.PlanType.map((plan, pIndex) => {
            selectedPlans.value[index][pIndex] = false
          })
          supplier.Term.map((plan, tIndex) => {
            selectedTerms.value[index][tIndex] = false
          })
        })
      }
      emitSelectedSuppliers(null, '');
    };

    // Toggle Dropdown
    const toggleDropdown = (index) => {
      showDropdown.value[index] = !showDropdown.value[index]
    }

    // const emitSelectedPlans = (index) => {
    //   if (selectedTerms.value[index].every(item => item === false)) {
    //     return
    //   }

    //   const selectedData = props.uniqueSuppliers.reduce((acc, supplier, sIndex) => {
    //     const hasSelectedTerms = selectedTerms.value[sIndex]?.some(val => val)
    //     const hasSelectedPlans = selectedPlans.value[sIndex]?.some(val => val)

    //     if (!hasSelectedTerms || !hasSelectedPlans) {
    //       return acc
    //     }

    //     const filteredTerms = supplier.Term.filter((_, tIndex) => selectedTerms.value[sIndex][tIndex])

    //     const selectedPlanValues = supplier.PlanType
    //       .filter((_, pIndex) => selectedPlans.value[sIndex][pIndex])
    //       .filter(Boolean)

    //     const expandedPlanSelection = supplier.PlanType.map(plan =>
    //       selectedPlanValues.some(selected => plan?.includes(selected))
    //     )

    //     const filteredPlans = supplier.PlanType.filter((_, pIndex) => expandedPlanSelection[pIndex])

    //     acc.push({
    //       Supplier: supplier.Supplier,
    //       Term: filteredTerms,
    //       PlanType: filteredPlans
    //     })

    //     return acc
    //   }, [])

    //   emit('update-selected-suppliers', selectedData)
    // }

    const emitSelectedPlans = (index) => {
      // If no term is selected for this supplier, skip emitting
      if (selectedTerms.value[index].every(item => item === false)) {
        return;
      }

      const selectedData = filteredSuppliers.value.reduce((acc, supplier, sIndex) => {
        const hasSelectedTerms = selectedTerms.value[sIndex]?.some(val => val);
        const hasSelectedPlans = selectedPlans.value[sIndex]?.some(val => val);

        // Skip if no selections at all for this supplier
        if (!hasSelectedTerms || !hasSelectedPlans) {
          return acc;
        }

        // Filter selected Terms
        const filteredTerms = supplier.Term.filter((_, tIndex) => selectedTerms.value[sIndex][tIndex]);

        // Filter selected PlanTypes directly by index (no .includes logic)
        const filteredPlans = supplier.PlanType.filter((_, pIndex) => selectedPlans.value[sIndex][pIndex]);

        acc.push({
          Supplier: supplier.Supplier,
          Term: filteredTerms,
          PlanType: filteredPlans
        });

        return acc;
      }, []);

      emit('update-selected-suppliers', selectedData);
    };

    // const emitSelectedTerms = (index) => {
    //   if (selectedPlans.value[index].every(item => item === false)) {
    //     return
    //   }

    //   const selectedData = props.uniqueSuppliers.reduce((acc, supplier, sIndex) => {
    //     const hasSelectedPlans = selectedPlans.value[sIndex]?.some(val => val)
    //     const hasSelectedTerms = selectedTerms.value[sIndex]?.some(val => val)

    //     if (!hasSelectedPlans || !hasSelectedTerms) {
    //       return acc
    //     }

    //     const selectedPlanValues = supplier.PlanType
    //       .filter((_, pIndex) => selectedPlans.value[sIndex][pIndex])
    //       .filter(Boolean)

    //     const expandedPlanSelection = supplier.PlanType.map(plan =>
    //       selectedPlanValues.some(selected => plan?.includes(selected))
    //     )

    //     const filteredPlans = supplier.PlanType.filter((_, pIndex) => expandedPlanSelection[pIndex])
    //     const filteredTerms = supplier.Term.filter((_, tIndex) => selectedTerms.value[sIndex][tIndex])

    //     acc.push({
    //       Supplier: supplier.Supplier,
    //       PlanType: filteredPlans,
    //       Term: filteredTerms
    //     })

    //     return acc
    //   }, [])

    //   emit('update-selected-suppliers', selectedData)
    // }

    const emitSelectedTerms = (index) => {
      // Skip if no plans are selected for the current supplier
      if (selectedPlans.value[index].every(item => item === false)) {
        return;
      }

      const selectedData = filteredSuppliers.value.reduce((acc, supplier, sIndex) => {
        const hasSelectedPlans = selectedPlans.value[sIndex]?.some(val => val);
        const hasSelectedTerms = selectedTerms.value[sIndex]?.some(val => val);

        // Only include suppliers with selected plans and terms
        if (!hasSelectedPlans || !hasSelectedTerms) {
          return acc;
        }

        const filteredPlans = supplier.PlanType.filter((_, pIndex) => selectedPlans.value[sIndex][pIndex]);
        const filteredTerms = supplier.Term.filter((_, tIndex) => selectedTerms.value[sIndex][tIndex]);

        acc.push({
          Supplier: supplier.Supplier,
          PlanType: filteredPlans,
          Term: filteredTerms
        });

        return acc;
      }, []);

      emit('update-selected-suppliers', selectedData);
    };



    const emitSelectedYears = () => {
      emit("updateyears", selectedYears.value);
    };

    // Check if all terms and all plans are selected for a supplier
    const isAllTermsSelected = (index) => {
      const terms = selectedTerms.value[index] || []
      const plans = selectedPlans.value[index] || []

      return terms.length && plans.length && terms.every(item => item === true) && plans.every(item => item === true)
    }

    // Check if partial selection (for minus icon)
    const isPartialTermsSelected = (index) => {
      const terms = selectedTerms.value[index] || []
      const plans = selectedPlans.value[index] || []

      const hasSomeTerms = terms.some(item => item === true)
      const hasSomePlans = plans.some(item => item === true)

      return (hasSomeTerms || hasSomePlans) && !isAllTermsSelected(index)
    }

    // Watch for changes in uniqueSuppliers to reinitialize the checkbox states
    watch(selectedYears, emitSelectedYears);
    watch(
      () => filteredSuppliers.value,
      (newSuppliers, oldSuppliers) => {
        if (newSuppliers && newSuppliers.length) {
          initializeCheckboxStatesChange(newSuppliers, oldSuppliers);
          // initializeCheckboxStates()
          emitSelectedSuppliers(null, '');
        }
      }, {
      immediate: true
    } // Run immediately to initialize on first render
    );
    watch(isYear, (newValue) => {
      emit('update:isYear', newValue);
    });

    watch(() => {
      emitSupplierRateList()
    })
    watch(showRenewableOnly, (value) => {
      emit("update-renewable-filter", value);
    });
    watch(filteredSuppliers, (value) => {
      console.log(
        value.map(s => ({
          supplier: s.Supplier,
          renewable: s.IsRenewable
        }))
      );
    });
    onMounted(async () => {
      selectedYears.value = [...years.value]; // Select all years by default
      emitSelectedYears(); // Emit the default selected years
      initializeCheckboxStates(); // Initialize the checkbox states
      emitSelectedSuppliers(null, '');
    });

    return {
      years,
      minMonths,
      maxMonths,
      emitSelectedYears,
      selectedYears,
      isYear,
      checkboxStates,
      allChecked,
      toggleAll,
      emitSelectedSuppliers,
      handleMaxUpdate,
      handleMinUpdate,
      showDropdown,
      selectedPlans,
      selectedTerms,
      toggleDropdown,
      emitSelectedTerms,
      emitSelectedPlans,
      emitSupplierRateList,
      isCustomQuote,
      isAllTermsSelected,
      isPartialTermsSelected,
      filteredSuppliers,
      showMainSuppliersOnly,
      mainSuppliers,
      showRenewableOnly

    };
  },
};
</script>

<style scoped>
.tab-row-data {
  overflow: auto;
  max-height: 88vh;
}

.toggle-row {
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background-color: #fff;
  height: 100%;
}

.year-checkbox {
  height: 25px;
  width: 25px;
}

.arrow-icon {
  cursor: pointer;
  /* font-size: 18px; */
  transition: color 0.3s;
}

.arrow-icon:hover {
  color: #e7660b;
  /* Bootstrap Primary Color */
}
</style>
